import * as atoms from '@/config/globalStateControl';

import { ActionIcon, Group, Text, createStyles } from '@mantine/core';
import { IconThumbUp, IconThumbUpFilled } from '@tabler/icons-react';

import ConfirmationPopup from '@/components/ConfirmationPopup';
import { isDark } from '@/utils/utils';
import mojs from '@mojs/core';
import themeVariables from '@/styles/themeVariables';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

const useBookmarkButtonStyles = createStyles(() => ({
  iconContainer: {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    gap: 0,
  },
}));

const burstObj = {
  className: 'BurstLike',
  radius: { 10: 60 },
  count: 10,
  top: 0,
  left: 0,
  duration: 1500,
  children: {
    shape: ['circle', 'polygon'],
    fill: ['#f3f3f3', '#52b8f1', '#d889fd'],
    angle: { 0: 5 },
    degreeShift: 'rand(-360, 360)',
    delay: 'stagger(0, 5)',
    isSwirl: true,
    swirlSize: 12,
    swirlFrequency: 'rand( 3, 6 )',
    pathScale: 'rand( .2, 1 )',
    direction: 'rand( 1, -1 )',
  },
};

let burstIndex = 0;

const LikeButton = ({
  id,
  size = 27,
  actionSize = 36,
  active = false,
  color = themeVariables.colors.red300,
  borderColor = themeVariables.colors.red300,
  onClick,
  className = '',
  label = '' as any,
  ...props
}) => {
  const isSignedIn = useAtomValue(atoms.isSignedIn);

  const { dark } = isDark();
  const { classes } = useBookmarkButtonStyles();

  const [filled, setFilled] = useState(active || false);

  const burst = new mojs.Burst(burstObj);
  burst.el.style.zIndex = 999;

  const buttonBurstsPool = [burst, burst, burst, burst, burst, burst];

  const handleLikeBtn = () => {
    const pos = document
      .getElementById(`thumbup-button-${id}`)
      ?.getBoundingClientRect();

    if (!filled) {
      buttonBurstsPool[burstIndex]
        .tune({
          x: (pos?.left || 0) + 10,
          y: (pos?.top || 0) + 20 + window.pageYOffset,
        })
        .generate()
        .replay();

      burstIndex =
        burstIndex >= buttonBurstsPool.length - 1 ? 0 : burstIndex + 1;
    }
  };

  return (
    <Group
      id={`thumbup-button-${id}`}
      variant={'transparent'}
      className={`${classes.iconContainer} ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!isSignedIn) {
          ConfirmationPopup.login();
          return;
        }

        onClick();
        setFilled((prev) => !prev);
        handleLikeBtn();
      }}
      sx={{ color: themeVariables.darkMode.normal(dark) }}
      {...props}
    >
      <ActionIcon size={actionSize} variant={'transparent'}>
        {filled ? (
          <IconThumbUpFilled size={size} stroke={2} style={{ color }} />
        ) : (
          <IconThumbUp
            size={size}
            stroke={1.75}
            fill={themeVariables.colors.transparent}
            color={borderColor}
          />
        )}
      </ActionIcon>
      <Text
        sx={(theme) => ({
          [theme.fn.smallerThan('sm')]: {
            display: 'none',
          },
        })}
      >
        {label}
      </Text>
    </Group>
  );
};

export default LikeButton;
